module.exports = __webpack_public_path__ + "static/boreal-logo-bb36c5de52dc7170d0ff1d8be1975c89.png";